import axios from 'axios';
import utilsService from '@/api/utilsService';

const base = `${process.env.VUE_APP_API_URL}/api/depuracion-modelo`;

function headers() {
  return { Authorization: `Bearer ${utilsService.getToken()}` };
}

// Los errores del API vienen como { message } o como texto plano.
function mensaje(error) {
  const data = error && error.response ? error.response.data : null;
  if (data && typeof data === 'object' && data.message) return data.message;
  if (typeof data === 'string' && data) return data;
  return (error && error.message) || 'Error en la solicitud';
}

const depuracionModeloService = {
  async getCorridas() {
    try {
      const r = await axios.get(`${base}/corridas`, { headers: headers() });
      return Array.isArray(r.data) ? r.data : [];
    } catch (e) {
      throw new Error(mensaje(e));
    }
  },

  // Respuesta grande (un registro por ítem del maestro); el API la envía comprimida.
  async getPayload(idCorrida) {
    try {
      const r = await axios.get(`${base}/corridas/${encodeURIComponent(idCorrida)}`, { headers: headers() });
      return r.data;
    } catch (e) {
      throw new Error(mensaje(e));
    }
  },

  async registrarCambios(idCorrida, cambios) {
    try {
      const r = await axios.post(`${base}/cambios`, { idCorrida, cambios }, { headers: headers() });
      return r.data;
    } catch (e) {
      throw new Error(mensaje(e));
    }
  },

  async revertir(ids) {
    try {
      const r = await axios.post(`${base}/cambios/revertir`, { ids }, { headers: headers() });
      return r.data;
    } catch (e) {
      throw new Error(mensaje(e));
    }
  },
};

export default depuracionModeloService;
